import { createI18n } from 'vue-i18n';
import zhCN from './zh-CN/index';
import jaJP from './ja-JP/index';

const locale = 'ja'; // 固定使用日语

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'ja',
  messages: {
    'zh-CN': zhCN,
    'ja': jaJP
  }
});
